/**********************************************************
Chemical App List: Lists all chemical products in the database
9/03/19
chemicalList: Array of chemical products
**********************************************************/
import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { determineIcon } from '../../cult_utils';

const propTypes = {
  chemAppList: PropTypes.array,
  deleteChemicalApplication: PropTypes.func
};

const ChemicalAppList = ({ chemAppList, chemicals, onClick }) => {
  if (!chemAppList) return <span>No Applications Available</span>;

  return (
    <div className="card">
      <ul className="collection">
        {
          chemAppList.map((c) => (
            <li key={c.id} className="collection-item chem-list-item" onClick={() => onClick(c)}>
              <span><b>{ moment(c.date).format('MM/DD/YYYY') }</b> - { c.fieldId }</span>
              <div className="fert-flex-list">
                {
                  c.solutions.map((s) => {
                    let chem = chemicals.find((_c) => _c.id === s.chemId);
                    let { color, icon } = determineIcon(chem.type);
                    return (
                      <span key={s.id} className="icon-shift">
                        <i className={`material-icons circle ${color} darken-2`}>{ icon }</i>
                      </span>
                    )
                  })
                }
              </div>
            </li>
          ))
        }
      </ul>
    </div>
  );
}

ChemicalAppList.propTypes = propTypes;
export default ChemicalAppList;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chem_app/chem_app_list.js